// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__77DLS","footer":"Form_footer__3vZar"};